module.exports = __webpack_public_path__ + "static/media/dev.a3d7818d.svg";